// src/components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner"; // or your toast library
import { useEffect, useRef } from "react";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const hasRedirected = useRef(false); // prevent double toast on re-render
  console.log(user)
  useEffect(() => {
    if (!loading && !user && !hasRedirected.current) {
      toast.warning("You need to be logged in to access this page.");
      hasRedirected.current = true;
    }
  }, [loading, user]);

  if (loading) return <div>Loading...</div>;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;